module.exports = __webpack_public_path__ + "img/130.95fd0f58.jpg";